import TYPE from "./alert.types";

export default class UsersAlertService {
 	 [x: string]: any;
 	 static $inject = ['$location','$translate'];
    constructor($location, $translate) {
        this.$translate = $translate;
        this.$location = $location;
        this.alertQueue = []
    }

    appendAlert(alert) {
        this.filterDuplicates(alert);
        this.alertQueue.push(alert);
    }

    prependAlert(alert) {
        this.filterDuplicates(alert);
        this.alertQueue.unshift(alert);
    }

    getAlert() {
        return this.alertQueue[0];
    }

    deleteAlert() {
        this.alertQueue.shift();
    }

    hasAlerts() {
        return this.alertQueue.length > 0;
    }

    clear() {
        this.alertQueue = [];
    }

    filterDuplicates(alert){
        this.alertQueue = this.alertQueue.filter(e => e !== alert);
    }

    deleteSuccessAlerts(){
        this.alertQueue = this.alertQueue.filter(a => a.type !== TYPE.SUCCESS);
    }
}
